import React, { useState, useEffect } from 'react';
import { useDesign } from '../../../context/contextDesign';
import { useReports } from '../../../context/Dashboard/contextReports';
import { Link } from 'react-router-dom';
import './style.css';

const getSeverityString = (level) => {
  if (level === 'CRITICAL') return "Critical";
  if (level === 'HIGH') return "High";
  if (level === 'MEDIUM') return "Medium";
  if (level === 'LOW') return "Low";
  return "None";
};

const calculateBackgroundColor = (riskFactor) => {
  switch (riskFactor) {
    case 'Critical': return '#6d2d9d';
    case 'High': return '#fc0000';
    case 'Medium': return '#ffc000';
    case 'Low': return '#92d14f';
    default: return '#006dc0';
  }
};

const RiskExposureList = ({ bHeightVal, ipVulTable, cloud, type }) => {
  const tableHeight = `calc(${bHeightVal} - 80vh)`;
  const props = { bHeightVal, ipVulTable };

  return (
    <div className="p-2 risk-exposure-list">
      <div className="card rounded-4 shadow-sm h-100 overflow-hidden"
        style={{ width: 560, minWidth: 500, backgroundColor: '#f9f9f9' }}>
        <div className="card-body d-flex flex-column" style={{ height: tableHeight }}>
          {!Array.isArray(ipVulTable) || ipVulTable.length === 0 ? (
            <div className="h-100 d-flex flex-column justify-content-center align-items-center text-center">
              <div className="icon-loader">
                <i className="bi bi-shield-fill-check" />
              </div>
              <h1>
                No <span style={{ color: '#e00f0f' }}>Vulnerability</span> Detected
              </h1>
            </div>
          ) : (
            <>
              <TableHeader />
              <div className="scrollbar-all-primary">
                <ExposureTable {...props} />
              </div>
              <BtnArea cloud={cloud} type={type} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RiskExposureList;

const TableHeader = () => (
  <>
    <div className="h-4 card-title text-center mb-3 pt-3 fw-bold text-dark">Risk Exposure List</div>
    <div className="col-12 mb-3 d-flex px-3" style={{ fontSize: 16, fontWeight: 600 }}>
      <div className='text-center' style={{ width: '60%', marginRight: 4 }}>Vulnerability</div>
      <div className='text-center' style={{ width: '20%', marginRight: 4 }}>Severity</div>
      <div className='text-center' style={{ width: '20%' }}>CVSS</div>
    </div>
  </>
);

const ExposureTable = ({ ipVulTable }) => {
  const { toggleEpssCard } = useDesign();
  const [vulnerabilities, setVulnerabilities] = useState([]);

  useEffect(() => {
    if (Array.isArray(ipVulTable)) {
      setVulnerabilities(ipVulTable);
    }
  }, [ipVulTable]);

  return (
    <div className="px-4">
      {vulnerabilities.map((vuln, index) => (
        <div
          className="py-2 d-flex flex-row align-items-center border-bottom"
          key={index}
          style={{ fontSize: 14 }}>
          <div
            style={{
              width: 300,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 600,
              color: '#343434',
            }}
          >
            <span className="fw-semibold text-dark">
              {vuln.title}
            </span>
          </div>
          <div className="text-center">
            <span
              className="badge rounded-pill fw-bold fs-6 px-3 py-1 my-1"
              style={{
                background: calculateBackgroundColor(
                  getSeverityString(vuln.baseSeverity)
                ),
                color: '#fff',
                width: 100,
                cursor: 'pointer',
              }}
              onClick={toggleEpssCard}
            >
              {getSeverityString(vuln.baseSeverity)}
            </span>
          </div>
          <div className="text-start">
            <span className="badge bg-secondary fw-bold ms-3" style={{ fontSize: 13 }}>
              {vuln.impact}
            </span>
          </div>
        </div>
      ))}
      <div className="text-center py-3 mb-5">
        <div style={{ width: 220, height: 10 }} />
      </div>
    </div>
  );
};

const BtnArea = ({ cloud, type }) => {
  return (
    <div className="w-100 text-center position-absolute bottom-0 start-50 translate-middle-x">
      <div
        style={{
          height: '30px',
          width: '100%',
          background: 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        }} />
      <div className="bg-white p-3 rounded-4">
        <Link to="/dashboard/reports">
          <button
            className="btn btn-dark border-0 px-4 py-2 rounded-3 fw-semibold"
            onClick={NavSelection(cloud, type)}
          >
            Show Detailed Report
          </button>
        </Link>
      </div>
    </div>
  );
};

const NavSelection = (cloud, type) => {
  const {
    awsEc2ReportNav,
    awsS3ReportNav,
    azureVmsReportNav,
    azureSasReportNav,
    gcpVmsReportNav,
    gcpSasReportNav,
  } = useReports();

  switch (cloud) {
    case 'aws':
      return type === 'ip' ? awsEc2ReportNav : awsS3ReportNav;
    case 'azure':
      return type === 'ip' ? azureVmsReportNav : azureSasReportNav;
    case 'gcp':
      return type === 'ip' ? gcpVmsReportNav : gcpSasReportNav;
    default:
      return;
  }
}